export default "__VITE_ASSET__Djv5vdgK__"